export default {
  computed: {
    locale_data() {
      return this.$context?._locale || {}
    },
    locales() {
      return this.locale_data.list || []
    },
    current_locale() {
      return this.locale_data.current || ''
    },
    default_locale() {
      return this.locale_data.default || ''
    },
    locale_urls() {
      return this.locale_data.redirects || ''
    },
  }
}
